import React from 'react';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border-t border-gray-700 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
            <p className="font-mono text-sm text-gray-400 tracking-wide">
              <span className="text-red-500">Hiopos</span>{' '}
              <span className="text-gray-500">México</span>
              <span className="text-gray-600 mx-2">|</span>
              <span className="text-gray-400">{currentYear}</span>
            </p>
          </div>
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex items-center gap-2">
              <span className="font-mono text-xs text-gray-600">Status:</span>
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="font-mono text-xs text-green-400">Online</span>
              </div>
            </div>
            <p className="font-mono text-xs text-gray-600">
              v1.0.0
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

